export const name = 'shoot_the_moon'
export const encrypt = 'tjttQZKdeu'
export const storageVersion = 3

export const shadow = 0.5
export const shadowTint = 0x888888
export const uiDropTime = 1000

export const release = true

// debug flags
export const clearStorage = release ? false :   false
export const state = release ? false :          false
export const shoot = release ? false :          false
export const cheat = release ? false :          false